module.exports = __webpack_public_path__ + "img/ssyx_14.49c20ecf.jpg";